import * as React from 'react';
import { NewMessage } from '../messages';

import './messages.scss';

const NewMessagePage: React.FC<{ match: { params: { orgId: string } } }> = ({ match }) => {
  const { orgId } = match.params;

  return (
    <div id="messages" className="container hub-full-width">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1>New Message</h1>
          </div>
        </div>

        <NewMessage orgId={orgId} />
      </div>
    </div>
  );
};

export default NewMessagePage;
